<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  <section [formGroup]="getControl('data')">
    <h1 class="section-header" id="earned-income-heading">Earned Income</h1>
    <hr />
    <ng-container formArrayName="income">
      <div
        class="details-container mb-2"
        role="table"
        aria-labelledby="earned-income-heading"
        [attr.aria-rowcount]="income.length + 1"
      >
        @if (isDesktop) {
        <div
          class="row g-3 p-2 bg-details-container"
          role="row"
          aria-rowindex="1"
        >
          <div
            class="col-md-3 ps-3 header-vertical-center"
            role="columnheader"
            aria-colindex="1"
            id="earned-income-person-header"
          >
            Person Name
          </div>
          <div
            class="col-md-3 ps-3 header-vertical-center"
            role="columnheader"
            aria-colindex="2"
            id="earned-income-frequency-header"
          >
            Frequency
          </div>
          <div
            class="col-md-2 ps-3 header-vertical-center"
            role="columnheader"
            aria-colindex="3"
            id="earned-income-employer-header"
          >
            Employer Name
          </div>
          <div
            class="col-md-2 ps-3 header-vertical-center"
            role="columnheader"
            aria-colindex="4"
            id="earned-income-amount-header"
          >
            Gross Amount
            <span>
              <nh-popover
                class="ps-1"
                iconMode="transparent"
                content="Gross income is your total income before taxes."
              >
              </nh-popover>
            </span>
          </div>
          <div
            class="col-md-2 text-center visually-hidden header-vertical-center"
            role="columnheader"
            aria-colindex="5"
            id="earned-income-actions-header"
          >
            Actions
          </div>
        </div>
        } @for (row of income.controls; track row; let i = $index) {
        <ng-container [formGroupName]="i">
          @if (this.getValue('iden', row) !== 'd') {
          <div
            class="row g-3 bg-even pl-3 pr-3 pt-3 pb-2"
            role="row"
            [attr.aria-rowindex]="i + 2"
          >
            <div class="col-md-3" role="cell" aria-colindex="1">
              <nh-field
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Person Name"
                class="label-section"
              >
                <select
                  nh
                  name="indvId"
                  [items]="individuals"
                  [attr.aria-labelledby]="
                    'earned-income-heading earned-income-person-header'
                  "
                  [attr.disabled]="
                    income.controls[i].value.indvId != null ? true : null
                  "
                  bindValue="identifier"
                  bindLabel="name.fullName"
                  formControlName="indvId"
                  (change)="onIndividualSelectForEarnedIncome(row)"
                ></select>
              </nh-field>
            </div>
            <div
              class="col-md-3"
              role="cell"
              aria-colindex="2"
              [formGroup]="$any(row).controls.wage"
            >
              <nh-field
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Frequency"
              >
                <select
                  nh
                  name="paymentPeriod"
                  [items]="tables.INCEXPPAYFREQUENCY"
                  [attr.aria-labelledby]="
                    'earned-income-heading earned-income-frequency-header'
                  "
                  formControlName="paymentPeriod"
                  (change)="onPaymentPeriodForEarnedIncome(row)"
                ></select>
              </nh-field>
            </div>
            <div
              class="col-md-2"
              role="cell"
              aria-colindex="3"
              [formGroup]="$any(row).controls.employer"
            >
              <nh-field
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Employer Name"
              >
                <input
                  nh
                  name="name"
                  type="text"
                  class="form-control"
                  [attr.aria-labelledby]="
                    'earned-income-heading earned-income-frequency-header'
                  "
                  formControlName="name"
                  (change)="onEmployerNameForEarnedIncome(row)"
                />
              </nh-field>
            </div>
            <div
              class="col-md-2"
              role="cell"
              aria-colindex="4"
              [formGroup]="$any(row).controls.wage"
            >
              <nh-field
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Gross Amount"
              >
                <nh-input-group prepend="$">
                  <input
                    nh
                    name="paymentAmountPerPayCheck"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=""
                    separatorLimit="999999999"
                    placeholder="0.00"
                    class="form-control"
                    [attr.aria-labelledby]="
                      'earned-income-heading earned-income-amount-header'
                    "
                    formControlName="paymentAmountPerPayCheck"
                    (change)="onPaymentAmountForEarnedIncome(row)"
                  />
                </nh-input-group>
              </nh-field>
            </div>
            <div
              class="hover-red text-center col-md-2"
              role="cell"
              aria-colindex="5"
            >
              <button
                class="btn btn-link btn-lg delete-{{ i }} hover-red p-1"
                [disabled]="
                  income.value[i].indvId == '' || income.value[i].indvId == null
                "
                (click)="removeEarnedIncomeRow(i, row)"
                [attr.aria-label]="'Remove Earned Income row ' + (i + 1)"
              >
                <span class="pe-2">Remove</span>
                <nh-remove-svg></nh-remove-svg>
              </button>
            </div>
          </div>
          }
        </ng-container>
        }
      </div>

      <div class="row">
        <div class="pt-1 hover-red text-start">
          <button
            class="btn btn-link btn-lg hover-red"
            (click)="addEarnedIncomeRow()"
            [disabled]="!getControl('data.income').valid"
          >
            <span class="pe-2">Add Another</span>
            <nh-add-svg></nh-add-svg>
          </button>
        </div>
      </div>
    </ng-container>

    <h2 class="section-header" id="self-employment-heading">
      Self-Employment Income
    </h2>
    <hr />
    <ng-container formArrayName="selfEmployment">
      <div
        class="details-container mb-2"
        role="table"
        aria-labelledby="self-employment-heading"
        [attr.aria-rowcount]="selfEmployment.length + 1"
      >
        @if (isDesktop) {
        <div
          class="row g-3 p-2 bg-details-container"
          role="row"
          aria-rowindex="1"
        >
          <div
            class="col-md-3 ps-3 header-vertical-center"
            role="columnheader"
            aria-colindex="1"
            id="self-employment-person-header"
          >
            Person Name
          </div>
          <div
            class="col-md-3 ps-3 header-vertical-center"
            role="columnheader"
            aria-colindex="2"
            id="self-employment-type-header"
          >
            Type
          </div>
          <div
            class="col-md-2 ps-3 header-vertical-center"
            role="columnheader"
            aria-colindex="3"
            id="self-employment-business-header"
          >
            Business Name
          </div>
          <div
            class="col-md-2 ps-3 header-vertical-center"
            role="columnheader"
            aria-colindex="4"
            id="self-employment-amount-header"
          >
            Monthly Net Amount
          </div>
          <div
            class="col-md-2 text-center visually-hidden header-vertical-center"
            role="columnheader"
            aria-colindex="5"
            id="self-employment-actions-header"
          >
            Actions
          </div>
        </div>
        } @for (row of selfEmployment.controls; track row; let i = $index) {
        <ng-container [formGroupName]="i">
          @if (this.getValue('iden', row) !== 'd') {
          <div
            class="row g-3 bg-even pl-3 pr-3 pt-3 pb-2"
            role="row"
            [attr.aria-rowindex]="i + 2"
          >
            <div class="col-md-3" role="cell" aria-colindex="1">
              <nh-field
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Person Name"
              >
                <select
                  nh
                  name="indvId"
                  [items]="individuals"
                  [attr.aria-labelledby]="
                    'self-employment-heading self-employment-person-header'
                  "
                  [attr.disabled]="
                    selfEmployment.controls[i].value.indvId != null
                      ? true
                      : null
                  "
                  bindValue="identifier"
                  bindLabel="name.fullName"
                  formControlName="indvId"
                  (change)="onIndividualSelectForSelfEmployment(row)"
                ></select>
              </nh-field>
            </div>
            <div class="col-md-3" role="cell" aria-colindex="2">
              <nh-field
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Type"
              >
                <select
                  nh
                  name="type"
                  [items]="tables.SELFEMPTYPE"
                  [attr.aria-labelledby]="
                    'self-employment-heading self-employment-type-header'
                  "
                  formControlName="type"
                  (change)="onTypeForSelfEmployment(row)"
                ></select>
              </nh-field>
            </div>
            <div class="col-md-2" role="cell" aria-colindex="3">
              <nh-field
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Business Name"
              >
                <input
                  nh
                  name="businessName"
                  type="text"
                  class="form-control"
                  [attr.aria-labelledby]="
                    'self-employment-heading self-employment-type-header'
                  "
                  formControlName="businessName"
                  (change)="onBusinessNameForSelfEmployment(row)"
                />
              </nh-field>
            </div>
            <div class="col-md-2" role="cell" aria-colindex="4">
              <nh-field
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Monthly Net Amount"
              >
                <nh-input-group prepend="$">
                  <input
                    nh
                    name="averageMonthlyProfit"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=""
                    separatorLimit="999999999"
                    placeholder="0.00"
                    class="form-control"
                    [attr.aria-labelledby]="
                      'self-employment-heading self-employment-amount-header'
                    "
                    formControlName="averageMonthlyProfit"
                    (change)="onMonthlyProfitForSelfEmployment(row)"
                  />
                </nh-input-group>
              </nh-field>
            </div>
            <div
              class="hover-red text-center col-md-2"
              role="cell"
              aria-colindex="5"
            >
              <button
                class="btn btn-link btn-lg delete-{{ i }} hover-red p-1"
                [disabled]="
                  selfEmployment.value[i].indvId == '' ||
                  selfEmployment.value[i].indvId == null
                "
                (click)="removeSelfEmpIncomeRow(i, row)"
                [attr.aria-label]="
                  'Remove Self-Employment Income row ' + (i + 1)
                "
              >
                <span class="pe-2">Remove</span>
                <nh-remove-svg></nh-remove-svg>
              </button>
            </div>
          </div>
          }
        </ng-container>
        }
      </div>
      <div class="row">
        <div class="pt-1 hover-red text-start">
          <button
            class="btn btn-link btn-lg hover-red"
            (click)="addSelfEmpIncomeRow()"
            [disabled]="!getControl('data.selfEmployment').valid"
          >
            <span class="pe-2">Add Another</span>
            <nh-add-svg></nh-add-svg>
          </button>
        </div>
      </div>
    </ng-container>

    <h2 class="section-header" id="other-income-heading">Other Income</h2>
    <hr />
    <div class="hint semibold">{{ otherIncomeTypeSSIEn }}</div>
    <br />
    <ng-container formArrayName="otherIncome">
      <div
        class="details-container mb-2"
        role="table"
        aria-labelledby="other-income-heading"
        [attr.aria-rowcount]="otherIncome.length + 1"
      >
        @if (isDesktop) {
        <div
          class="row g-3 p-2 bg-details-container"
          role="row"
          aria-rowindex="1"
        >
          <div
            class="col-md-3 ps-3 header-vertical-center"
            role="columnheader"
            aria-colindex="1"
            id="other-income-person-header"
          >
            Person Name
          </div>
          <div
            class="col-md-2 ps-3 header-vertical-center"
            role="columnheader"
            aria-colindex="2"
            id="other-income-type-header"
          >
            Type
          </div>
          <div
            class="col-md-2 ml-2 ps-3 header-vertical-center"
            role="columnheader"
            aria-colindex="3"
            id="other-income-frequency-header"
          >
            Frequency
          </div>
          <div
            class="col-md-3 ml-3 ps-3 header-vertical-center"
            role="columnheader"
            aria-colindex="4"
            id="other-income-amount-header"
          >
            Gross Amount
            <span>
              <nh-popover
                class="ps-1"
                iconMode="transparent"
                content="Gross pay is how much you get paid before taxes."
              >
              </nh-popover>
            </span>
          </div>
          <div
            class="col-md-2 text-center visually-hidden header-vertical-center"
            role="columnheader"
            aria-colindex="5"
            id="other-income-actions-header"
          >
            Actions
          </div>
        </div>
        } @for (row of otherIncome.controls; track row; let i = $index) {
        <ng-container [formGroupName]="i">
          @if (this.getValue('iden', row) !== 'd') {
          <div
            class="row g-3 bg-even pl-3 pr-3 pt-3 pb-2"
            role="row"
            [attr.aria-rowindex]="i + 2"
          >
            <div class="col-md-3" role="cell" aria-colindex="1">
              <nh-field
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Person Name"
                class="label-section"
              >
                <select
                  nh
                  name="indvId"
                  [attr.aria-labelledby]="
                    'other-income-heading other-income-person-header'
                  "
                  [attr.disabled]="
                    otherIncome.controls[i].value.indvId != null ? true : null
                  "
                  [items]="individuals"
                  bindValue="identifier"
                  bindLabel="name.fullName"
                  formControlName="indvId"
                  (change)="onIndividualSelectForOtherIncome(row)"
                ></select>
              </nh-field>
            </div>
            <div
              class="col-md-2"
              role="cell"
              aria-colindex="2"
              [formGroup]="$any(row).controls.otherIncomeDetails"
            >
              <nh-field
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Type"
              >
                <select
                  class="zoom-friendly-select"
                  nh
                  name="otherIncomeTypeCode"
                  [items]="tables.UNEARNEDINCOMETYPE_PP"
                  [attr.aria-labelledby]="
                    'other-income-heading other-income-type-header'
                  "
                  (change)="
                    onOtherIncomeChange(
                      otherIncome.value[i].otherIncomeDetails
                        .otherIncomeTypeCode.code,
                      row
                    )
                  "
                  formControlName="otherIncomeTypeCode"
                  (change)="onCodeForOtherIncome(row)"
                ></select>
              </nh-field>
            </div>
            <div
              class="col-md-2"
              role="cell"
              aria-colindex="3"
              [formGroup]="$any(row).controls.otherIncomeDetails"
            >
              <nh-field
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Frequency"
                class="pl-0"
              >
                <select
                  nh
                  name="paymentFrequency"
                  [items]="tables.INCEXPPAYFREQUENCY"
                  [attr.aria-labelledby]="
                    'other-income-heading other-income-frequency-header'
                  "
                  formControlName="paymentFrequency"
                  (change)="onFrequencyForOtherIncome(row)"
                ></select>
              </nh-field>
            </div>
            <div
              class="col-md-3"
              role="cell"
              aria-colindex="4"
              [formGroup]="$any(row).controls.otherIncomeDetails"
            >
              <nh-field
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Gross Amount"
                class="pl-0"
              >
                <nh-input-group prepend="$">
                  <input
                    nh
                    name="paymentAmount"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=""
                    separatorLimit="999999999"
                    placeholder="0.00"
                    class="form-control"
                    [attr.aria-labelledby]="
                      'other-income-heading other-income-amount-header'
                    "
                    formControlName="paymentAmount"
                    (change)="onPaymentAmountForOtherIncome(row)"
                  />
                </nh-input-group>
              </nh-field>
            </div>
            <div
              class="text-center col-md-2 hover-red"
              role="cell"
              aria-colindex="5"
            >
              <button
                class="btn btn-link btn-lg delete-{{ i }} hover-red p-1"
                [disabled]="
                  otherIncome.value[i].indvId == '' ||
                  otherIncome.value[i].indvId == null
                "
                (click)="removeOtherIncomeRow(i, row)"
                [attr.aria-label]="'Remove Other Income row ' + (i + 1)"
              >
                <span class="pe-2">Remove</span>
                <nh-remove-svg></nh-remove-svg>
              </button>
            </div>
            @if
            (incomeTypeAlp(otherIncome?.value[i]?.otherIncomeDetails.otherIncomeTypeCode?.code))
            {
            <div
              class="container"
              [formGroup]="$any(row).controls.otherIncomeDetails"
            >
              <div class="row">
                <div class="col-12 col-md-4 offset-md-3">
                  <nh-field
                    [mandatory]="false"
                    [attr.aria-required]="false"
                    label="Alimony Order Date"
                  >
                    <nh-datepicker>
                      <input
                        type="text"
                        class="form-control"
                        name="alimonyOrderDate"
                        formControlName="alimonyOrderDate"
                        placeholder="mm/dd/yyyy"
                        [maxDate]="today"
                        bsDatepicker
                        nh
                      />
                    </nh-datepicker>
                  </nh-field>
                </div>
              </div>
            </div>
            }
          </div>
          }
        </ng-container>
        }
      </div>
      <div class="row">
        <div class="pt-1 hover-red text-start">
          <button
            class="btn btn-link btn-lg hover-red"
            (click)="addOtherIncomeRow()"
            [disabled]="!getControl('data.otherIncome').valid"
          >
            <span class="pe-2">Add Another</span>
            <nh-add-svg></nh-add-svg>
          </button>
        </div>
      </div>
    </ng-container>

    <h2 class="section-header" id="tax-deductions-heading">Tax Deductions</h2>
    <hr />
    <ng-container formArrayName="taxDeductionsData">
      <div
        class="details-container mb-2"
        role="table"
        aria-labelledby="tax-deductions-heading"
        [attr.aria-rowcount]="taxDeductionsData.length + 1"
      >
        @if (isDesktop) {
        <div
          class="row g-3 p-2 bg-details-container"
          role="row"
          aria-rowindex="1"
        >
          <div
            class="col-md-3 ps-3 header-vertical-center"
            role="columnheader"
            aria-colindex="1"
            id="tax-deductions-person-header"
          >
            Person Name
          </div>
          <div
            class="col-md-3 ps-3 header-vertical-center"
            role="columnheader"
            aria-colindex="2"
            id="tax-deductions-type-header"
          >
            Type
          </div>
          <div
            class="col-md-3 ps-3 header-vertical-center"
            role="columnheader"
            aria-colindex="3"
            id="tax-deductions-amount-header"
          >
            Monthly Amount
          </div>
          <div
            class="col-md-3 ps-3 text-center visually-hidden header-vertical-center"
            role="columnheader"
            aria-colindex="4"
            id="tax-deductions-actions-header"
          >
            Actions
          </div>
        </div>
        } @for (row of taxDeductionsData.controls; track row; let i = $index) {
        <ng-container [formGroupName]="i">
          @if (this.getValue('iden', row) !== 'd') {
          <div
            class="row g-3 bg-even pl-3 pr-3 pt-3 pb-2"
            role="row"
            [attr.aria-rowindex]="i + 2"
          >
            <div class="col-md-3" role="cell" aria-colindex="1">
              <nh-field
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Person Name"
              >
                <select
                  nh
                  name="indvId"
                  [items]="individuals"
                  [attr.aria-labelledby]="
                    'tax-deductions-heading tax-deductions-person-header'
                  "
                  [attr.disabled]="
                    taxDeductionsData.controls[i].value.indvId != null
                      ? true
                      : null
                  "
                  bindValue="identifier"
                  bindLabel="name.fullName"
                  formControlName="indvId"
                  (change)="onIndividualSelectForTaxDeduction(row)"
                ></select>
              </nh-field>
            </div>
            <div class="col-md-3" role="cell" aria-colindex="2">
              <nh-field
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Type"
              >
                <select
                  class="zoom-friendly-select"
                  nh
                  name="deductionType"
                  [items]="tables.MPDEDUCTIONS"
                  [attr.aria-labelledby]="
                    'tax-deductions-heading tax-deductions-type-header'
                  "
                  (change)="
                    onTaxTypeChange(
                      taxDeductionsData.value[i].deductionType.code,
                      row
                    )
                  "
                  formControlName="deductionType"
                  (change)="onCodeForTaxDeduction(row)"
                ></select>
              </nh-field>
            </div>
            <div class="col-md-3" role="cell" aria-colindex="3">
              <nh-field
                [showLabel]="!isDesktop"
                [isRow]="true"
                [mandatory]="false"
                [attr.aria-required]="false"
                label="Monthly Amount"
              >
                <nh-input-group prepend="$">
                  <input
                    nh
                    name="deductionAmount"
                    type="text"
                    mask="separator.2"
                    thousandSeparator=""
                    separatorLimit="999999999"
                    placeholder="0.00"
                    class="form-control"
                    [attr.aria-labelledby]="
                      'tax-deductions-heading tax-deductions-amount-header'
                    "
                    formControlName="deductionAmount"
                    (change)="onAmountForTaxDeduction(row)"
                  />
                </nh-input-group>
              </nh-field>
            </div>
            <div
              class="hover-red text-center col-md-3"
              role="cell"
              aria-colindex="4"
            >
              <button
                class="btn btn-link btn-lg delete-{{ i }} hover-red p-1"
                [disabled]="
                  taxDeductionsData.value[i].indvId == '' ||
                  taxDeductionsData.value[i].indvId == null
                "
                (click)="removeTaxDeductionsRow(i, row)"
                [attr.aria-label]="'Remove Tax Deduction row ' + (i + 1)"
              >
                <span class="pe-2">Remove</span>
                <nh-remove-svg></nh-remove-svg>
              </button>
            </div>
          </div>
          }
          <!-- TEDS-168263 Start here -->
          <div class="container">
            <div class="row">
              <div class="col-md-3"></div>
              @if (taxTypeAlp(taxDeductionsData?.value[i]?.deductionType?.code))
              {
              <div class="col-md-6">
                <nh-field
                  [mandatory]="false"
                  [attr.aria-required]="false"
                  label="Alimony Order Date"
                >
                  <nh-datepicker>
                    <input
                      type="text"
                      class="form-control"
                      name="alimonyOrderDate"
                      formControlName="alimonyOrderDate"
                      placeholder="mm/dd/yyyy"
                      [maxDate]="today"
                      bsDatepicker
                      nh
                    />
                  </nh-datepicker>
                </nh-field>
              </div>
              }
              <div class="col-md-3"></div>
            </div>
          </div>
          <!-- TEDS-168263Ends Here -->
        </ng-container>
        }
      </div>
      <div class="row">
        <div class="pt-1 hover-red text-start">
          <button
            class="btn btn-link btn-lg hover-red"
            (click)="addTaxDeductionsRow()"
            [disabled]="!getControl('data.taxDeductionsData').valid"
          >
            <span class="pe-2">Add Another</span>
            <nh-add-svg></nh-add-svg>
          </button>
        </div>
      </div>
    </ng-container>
  </section>
</nh-form>